import { FC } from 'react';
import type { ScheduledCall } from '@teachur/http-client';

interface ScheduleStatusMessageProps {
  status?: ScheduledCall['status'];
  isMissed?: boolean;
}

const SCHEDULE_STATUS_MESSAGE_CONFIG = {
  pending: {
    backgroundColorClassName: 'bg-(--warning-W100)',
    textColorClassName: 'text-(--warning-W700)',
    message:
      'Congratulations on requesting a Course Hearing! Once an Instructor confirms your request, the video link will appear for you to join at the appointed time.',
  },
  rejected: {
    backgroundColorClassName: 'bg-(--danger-D200)',
    textColorClassName: 'text-(--danger-D700)',
    message:
      'This meeting was rejected. Please choose a new available time for your course hearing.',
  },
  accepted: {
    backgroundColorClassName: 'bg-(--success-S200)',
    textColorClassName: 'text-(--success-S700)',
    message:
      'Your instructor accepted the meeting time, and your course hearing has been scheduled. You can join the call by clicking the Join now button at the scheduled time.',
  },
  missed: {
    backgroundColorClassName: 'bg-(--danger-D200)',
    textColorClassName: 'text-(--danger-D700)',
    message:
      'The scheduled time for this course hearing has passed and the call did not take place. Please choose a new available time for your course hearing.',
  },
} satisfies Partial<
  Record<
    ScheduledCall['status'] | 'missed',
    {
      backgroundColorClassName: string;
      textColorClassName: string;
      message: string;
    }
  >
>;

export const ScheduleStatusMessage: FC<ScheduleStatusMessageProps> = ({ status, isMissed }) => {
  if (!status) return null;

  const statusConfig = SCHEDULE_STATUS_MESSAGE_CONFIG[isMissed ? 'missed' : status];

  if (!statusConfig) return null;

  return (
    <div className={`flex w-fit rounded-xl px-5 py-4 ${statusConfig.backgroundColorClassName}`}>
      <p
        className={`m-0! [font-size:var(--fs-p4)]! lg:[font-size:var(--fs-p3)]! font-medium ${statusConfig.textColorClassName}`}
      >
        {statusConfig.message}
      </p>
    </div>
  );
};
